import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Sumarigrama';

export interface Sumarigrama {
 jerarquia:any[];
 idVersion: number;
}

export interface SumarigramaNode {
    id: number;
    descripcion: string;
    hijos: SumarigramaNode[];
    tipo: string;
    nivel: number;
}

export interface SumarigramaRequest {
	idVersion?: number;
	año?: number;
	periodo?: number;
	idTipoContenido?: string;
   }

export class SumarigramaAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	SumarigramaUsuario(request: SumarigramaRequest): AxiosPromise<Sumarigrama> {
		return this.cliente.post(request, `/SumarigramaUsuario`);
	}

	Sumarigrama(idVersion?:number): AxiosPromise<Sumarigrama> {
		if(idVersion && idVersion!==null)
		{
			return this.cliente.get(`/${idVersion}`);
		}else{
			return this.cliente.get();
		}
	}

	DescargarSumarigrama(data: any): AxiosPromise<Blob> {
        return this.cliente.postDownloadFile(data, `/DescargarSumarigrama`);
    }
}